import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Search } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

function formatDate(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch { return iso; }
}

export default function FreeDomainsPage() {
  const navigate = useNavigate();
  const [all,     setAll]     = useState([]);
  const [loading, setLoading] = useState(false);
  const [search,  setSearch]  = useState('');

  useEffect(() => {
    setLoading(true);
    axios.get(`${API}/api/partners/free-domains`, { withCredentials: true })
      .then(r => setAll(r.data.data || []))
      .catch(e => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  const filtered = search.trim()
    ? all.filter(r => r.domain?.toLowerCase().includes(search.toLowerCase()))
    : all;

  return (
    <div data-testid="free-domains-page">
      <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>
        Dashboard &gt;{' '}
        <span style={{ cursor: 'pointer', color: '#3182ce' }} onClick={() => navigate('/partners')} data-testid="free-back-link">
          Partner Dashboard
        </span>{' '}
        &gt; Free Email Domains
      </div>

      <div className="page-header">
        <h1>Free Email Domains</h1>
        <p>Domains blocked from registration (free/consumer email providers)</p>
      </div>

      <div className="filter-bar" style={{ alignItems: 'flex-end' }}>
        <div className="filter-group" style={{ flex: 3 }}>
          <label className="filter-label">Search domain</label>
          <div style={{ position: 'relative' }}>
            <Search size={14} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#999' }} />
            <input
              type="text"
              className="filter-input"
              style={{ paddingLeft: 30 }}
              placeholder="Filter domains…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              data-testid="free-search-input"
            />
          </div>
        </div>
        {search && (
          <button className="btn btn-secondary" onClick={() => setSearch('')} data-testid="free-search-reset">
            Reset
          </button>
        )}
      </div>

      <div className="table-container">
        <div className="table-header">
          <div>
            <span className="table-title" style={{ fontFamily: 'monospace' }}>free_email_domains</span>
            <span className="table-count" style={{ marginLeft: 8 }}>
              ({filtered.length.toLocaleString()}{search ? ` of ${all.length}` : ''} rows)
            </span>
          </div>
        </div>

        {loading ? (
          <div style={{ padding: 40, textAlign: 'center' }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
        ) : filtered.length === 0 ? (
          <div className="empty-state">
            <h3>No rows found</h3>
            <p>{search ? 'Try a different search term' : 'Table appears to be empty'}</p>
          </div>
        ) : (
          <div className="table-scroll">
            <table data-testid="free-domains-table">
              <thead>
                <tr>
                  <th>DOMAIN</th>
                  <th>ADDED BY</th>
                  <th>ADDED</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row, i) => (
                  <tr key={i} data-testid={`free-row-${i}`}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{row.domain}</td>
                    <td style={{ fontSize: 12 }}>{row.added_by || <span style={{ color: '#ccc' }}>—</span>}</td>
                    <td style={{ fontSize: 11, color: '#718096', whiteSpace: 'nowrap' }}>{formatDate(row.added_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
